import { compose, either, equals, path } from 'ramda'

/**
 * Identifies whether the enter key was pressed or not from an event.
 *
 * @function
 * @param {Object} event
 * @return {Boolean}
 */
const enterKeyPressed = compose(
  either(equals(13), equals('13')),
  either(path(['keyCode']), path(['which'])),
)

export default enterKeyPressed
